import { isDestinationInHIPAAMode } from "@/util";
import { WizardCompletionSummary } from "../framework/types";
import { EnableDestinationContext, EnableDestinationData } from "./types";

/** Claims only what the wizard's checks recorded. */
export function getEnableDestinationSummary(
  destinationName: string | undefined,
  data: Pick<
    EnableDestinationData,
    "liveViewSeenAt" | "deliveredAt" | "confirmedInDestination"
  >,
  {
    configuredDestination,
    isHipaaV2,
  }: Pick<EnableDestinationContext, "configuredDestination" | "isHipaaV2">,
): WizardCompletionSummary {
  const name = destinationName ?? "your destination";
  const Name = destinationName ?? "Your destination";
  if (!configuredDestination?.enabled) {
    return {
      title: `${Name} isn’t on yet`,
      description: `Turn ${name} on from its destination page to start sending events.`,
    };
  }

  const highlights = [
    data.liveViewSeenAt && "Events seen in Live View",
    data.deliveredAt && `Delivery to ${name} confirmed`,
    data.confirmedInDestination && `Events confirmed in ${name}`,
    isHipaaV2 &&
      isDestinationInHIPAAMode(configuredDestination) &&
      "HIPAA safeguards applied",
  ].filter((highlight): highlight is string => !!highlight);
  const footer = `You can change what ${name} receives anytime from its destination page.`;

  if (data.confirmedInDestination || data.deliveredAt) {
    return {
      title: `${Name} is live`,
      description: `${Name} is receiving events from Freshpaint. ${footer}`,
      highlights,
    };
  }
  return {
    title: `${Name} is on`,
    description: `Freshpaint will send ${name} the events you chose. Check its destination page to confirm they arrive and to change what it receives.`,
    highlights,
  };
}
